import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface MasterConceptGroup {
  id?: string
  code: string
  description: string
  countryId?: string
  updated_at?: string
}

export async function getMasterConceptGroups(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  const where = ['country_id = :countryId']

  if (search) {
    where.push(`CONCAT(code,description) ILIKE '%${search}%'`)
  }

  let modifier = []
  dataOrder !== ''
    ? (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = ['ORDER BY code'])

  return await getData({
    tables: ['pg_master_concept_groups'],
    fields: ['id', 'code', 'description', 'updated_at'],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
}

export async function getMasterConceptGroup(
  id: string
): Promise<MasterConceptGroup> {
  const data = await getData<any>({
    tables: ['pg_master_concept_groups'],
    fields: ['*'],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 1 }
    }
  })

  return data[0].results[0]
}

export async function createMasterConceptGroup(
  data: MasterConceptGroup
): Promise<boolean> {
  const response: any = await http.post('concept/concept-groups', {
    code: data.code,
    description: data.description,
    countryId: data.countryId
  })

  return !response?.data?.data?.error
}

export async function updateMasterConceptGroup(
  data: Pick<MasterConceptGroup, 'description'>,
  id: string
): Promise<boolean> {
  const response: any = await http.put(`concept/concept-groups/${id}`, {
    id,
    description: data.description
  })

  return !response?.data?.data?.error
}

export async function deleteMasterConceptGroup(id: string): Promise<boolean> {
  const response: any = await http.delete(`concept/concept-groups/${id}`)

  return !response?.data?.data?.error
}
